import React from "react";
import Header from "../../Header";
import Footer from "../../Footer";
import PageTitle from "./PageTitle";
import ErrorContent from "./ErrorContent";

const Error404 = () => {
	return (
		<>
			<Header />
			<PageTitle />
			<ErrorContent />
			<Footer />
		</>
	);
};
export default Error404;
